export function setProducts(state, products){
    state.products = products
}
export function setTypeBuild(state, tabIndex){
    state.tabIndex = tabIndex
}
export function setCodeBranch(state, code_branch_office){
    state.code_branch_office = code_branch_office
}
export function setBranchOffices_refactor(state, branch_offices){
    state.branch_offices = branch_offices
}
export function setVoucherTypes(state, voucherTypes) {
    state.voucherTypes = voucherTypes.map(p => {
        return {
            value: p.id,
            label: p.name_voucher_type,
            code: p.code_voucher_type,
            consecutive_number: p.consecutive_number
        };
    });
}
export function setDocuments(state, documents) {
    state.documents = documents.map(p => {
        return {
            value: p.id,
            label: (p.prefix && p.prefix.trim().length > 0) ?  p.prefix.trim() +'-'+p.consecutive:p.consecutive,
        };
    });
}
export function setNullVoucherTypeId(state, documents) {
    state.params.voucher_type_id = null;
    state.voucherTypes = [];
}
export function setNullDocumentId(state, documents) {
    state.params.document_id = null;
    state.documents = [];
}
export function setTypeRefactor(state, type) {
    state.params.type_refactor = type;
}
export function slearState(state) {
    state.voucherTypes=[],
    state.documents=[],
    state.code_branch_office=null,
    state.params = {
      date: null,
      product_ids : [],
      voucher_type_id : null,
      branch_office_id : null,
      document_id : null,
      type_refactor : "",
    }
}



// WEBPACK FOOTER //
// ./src/modules/rebuild/mutations.js